import React from "react";
import {
  Lock,
  LocalPhone,
  MailOutline,
  DriveFileRenameOutline,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { Box, Container, Grid } from "@mui/material";

import HeadingText from "./HeadingText";

function Personal({ register, errors, onEmailBlur, setValue }) {
  const [showPassword, setShowPassword] = React.useState(false);
  const [showRePassword, setShowRePassword] = React.useState(false);

  return (
    <Container maxWidth="md">
      <Grid container>
        <Grid item xs={12} sm={5}>
          <HeadingText
            main="Personal Information"
            sub="Input all the required information to continue."
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <DriveFileRenameOutline
              color="primary"
              sx={{
                position: "absolute",
                top: "25px",
                left: "12px",
              }}
            />
            <label
              style={{
                position: "absolute",
                left: 10,
                top: 0,
                color: "#186FE7",
                fontSize: 14,
              }}
            >
              Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="text"
              placeholder="Enter Name"
              style={{ marginTop: 20 }}
              {...register("name", {
                onChange: (e) => {
                  const sanitized = e.target.value.replace(/[^A-Za-z\s]/g, "");
                  setValue("name", sanitized);
                },
              })}
            />
            {errors.name && <p className="error">{errors.name.message}</p>}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <MailOutline
              color="primary"
              sx={{
                position: "absolute",
                top: "25px",
                left: "12px",
              }}
            />
            <label
              style={{
                position: "absolute",
                left: 10,
                top: 0,
                color: "#186FE7",
                fontSize: 14,
              }}
            >
              Email <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="email"
              placeholder="Enter Email"
              style={{ marginTop: 20 }}
              {...register("mail")}
              onBlur={(e) => onEmailBlur?.(e.target.value)}
            />
            {errors.mail && <p className="error">{errors.mail.message}</p>}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <LocalPhone
              color="primary"
              sx={{
                position: "absolute",
                top: "25px",
                left: "12px",
              }}
            />
            <label
              style={{
                position: "absolute",
                left: 10,
                top: 0,
                color: "#186FE7",
                fontSize: 14,
              }}
            >
              Phone Number <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="tel"
              placeholder="Enter Phone Number"
              style={{ marginTop: 20 }}
              {...register("phone", {
                onChange: (e) => {
                  let input = e.target.value;
            
                  // Allow only digits and '+' at the start
                  input = input.replace(/[^\d+]/g, ""); // Remove everything except digits and '+'
            
                  // Remove '+' if it's not the first character
                  if (input.indexOf("+") > 0) {
                    input = input.replace(/\+/g, ""); // remove all '+'
                  }
            
                  // Keep '+' only at the start (if present)
                  if (input.startsWith("+")) {
                    input = "+" + input.slice(1).replace(/\+/g, "");
                  }
            
                  setValue("phone", input);
                },
              })}
            
            />
            {errors.phone && <p className="error">{errors.phone.message}</p>}
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={5}>
          <HeadingText main="Enter Password" sub="Enter a secret password." />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <label
              style={{
                position: "absolute",
                left: 10,
                top: 0,
                color: "#186FE7",
                fontSize: 14,
              }}
            >
              Password <span style={{ color: "red" }}>*</span>
            </label>
            <Lock
              color="primary"
              sx={{
                position: "absolute",
                top: "25px",
                left: "12px",
              }}
            />
            <input
              className="text_input"
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              style={{ marginTop: 20, paddingRight: 40 }}
              {...register("pass")}
            />
            <Box
              onClick={() => setShowPassword(!showPassword)}
              sx={{
                position: "absolute",
                right: 10,
                top: "25px",
                cursor: "pointer",
              }}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </Box>
            {errors.pass && <p className="error">{errors.pass.message}</p>}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "24px" }}>
            <Lock
              color="primary"
              sx={{
                position: "absolute",
                top: "25px",
                left: "12px",
              }}
            />
            <label
              style={{
                position: "absolute",
                left: 10,
                top: 0,
                color: "#186FE7",
                fontSize: 14,
              }}
            >
              Retype Password <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type={showRePassword ? "text" : "password"}
              placeholder="Retype Password"
              style={{ marginTop: 20, paddingRight: 40 }}
              {...register("rePass")}
            />
            <Box
              onClick={() => setShowRePassword(!showRePassword)}
              sx={{
                position: "absolute",
                right: 10,
                top: "25px",
                cursor: "pointer",
              }}
            >
              {showRePassword ? <VisibilityOff /> : <Visibility />}
            </Box>
            {errors.rePass && <p className="error">{errors.rePass.message}</p>}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Personal;
